/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateTableColumn } from './FormulaEvaluateTableColumn';
import {
    FormulaEvaluateTableColumnFromJSON,
    FormulaEvaluateTableColumnFromJSONTyped,
    FormulaEvaluateTableColumnToJSON,
    FormulaEvaluateTableColumnToJSONTyped,
} from './FormulaEvaluateTableColumn';
import type { DataInnerInner } from './DataInnerInner';
import {
    DataInnerInnerFromJSON,
    DataInnerInnerFromJSONTyped,
    DataInnerInnerToJSON,
    DataInnerInnerToJSONTyped,
} from './DataInnerInner';

/**
 * 
 * @export
 * @interface FormulaEvaluateTableInput
 */
export interface FormulaEvaluateTableInput {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    columns: Array<FormulaEvaluateTableColumn>;
    /**
     * 
     */
    data: Array<Array<DataInnerInner>>;
}

/**
 * Check if a given object implements the FormulaEvaluateTableInput interface.
 */
export function instanceOfFormulaEvaluateTableInput(value: object): value is FormulaEvaluateTableInput {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('columns' in value) || value['columns'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FormulaEvaluateTableInputFromJSON(json: any): FormulaEvaluateTableInput {
    return FormulaEvaluateTableInputFromJSONTyped(json, false);
}

export function FormulaEvaluateTableInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateTableInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'columns': ((json['columns'] as Array<any>).map(FormulaEvaluateTableColumnFromJSON)),
        'data': json['data'],
    };
}

export function FormulaEvaluateTableInputToJSON(json: any): FormulaEvaluateTableInput {
    return FormulaEvaluateTableInputToJSONTyped(json, false);
}

export function FormulaEvaluateTableInputToJSONTyped(value?: FormulaEvaluateTableInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'columns': ((value['columns'] as Array<any>).map(FormulaEvaluateTableColumnToJSON)),
        'data': value['data'],
    };
}

